import { MarketProgram } from '@/features/bidding/constants'
import type { BidDirection } from '@/features/bidding/types/bidLadderInput'

/**
 * Determines the bid direction from a market program.
 * UP programs map to 'up' direction, DOWN programs map to 'down' direction.
 *
 * @param marketProgram - The market program to convert
 * @returns The bid direction ('up' or 'down')
 */
export function getDirectionFromMarketProgram(marketProgram: MarketProgram): BidDirection {
  switch (marketProgram) {
    // mFRR markets
    case MarketProgram.MFRR_UP:
      return 'up'
    case MarketProgram.MFRR_DOWN:
      return 'down'
    // FCR-D markets (dynamic)
    case MarketProgram.NORDICS_FCRD_UP_DYNAMIC:
      return 'up'
    case MarketProgram.NORDICS_FCRD_DOWN_DYNAMIC:
      return 'down'
    // FCR-D markets (static)
    case MarketProgram.NORDICS_FCRD_UP_STATIC:
      return 'up'
    case MarketProgram.NORDICS_FCRD_DOWN_STATIC:
      return 'down'
    // Legacy FCR-D
    case MarketProgram.FCRD_UP:
      return 'up'
    case MarketProgram.FCRD_DOWN:
      return 'down'
    default:
      // Default to 'up' for symmetric markets (FCR-N) and other programs
      return 'up'
  }
}
